// extracted by mini-css-extract-plugin
export default {"triggerButton":"qRz1TXQBZcF_5xzbxOIo"};